import { createSelector } from 'reselect';
import InternalRepatriationReportColumns from '../../containers/InternalRepatriationReportColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.REPORTING_INTERNAL_REPATRIATIONS.isLoading;
export const getData = TableDefinitions.REPORTING_INTERNAL_REPATRIATIONS.getDataFunction();
export const getColumns = createSelector(getData, InternalRepatriationReportColumns);
